import { useState } from 'react';
import { message, ModalProps } from 'antd';
import { useTranslate } from '@tolgee/react';
import styled from '@emotion/styled';
import { InfoCircleFilled } from '@ant-design/icons';
import { authJolectShop } from 'services/api/jolect';
import { Dialog, TitleText, TitleWrap } from './components/styles';
import JolectAuthForm, { JolectAuthFormValues } from './components/JolectAuthForm';

export interface JolectShopDialogProps extends ModalProps {
  isConfigService: boolean;
  onConfigService: (e: any) => void;
}

const JolectAuthShopDialog = (props: JolectShopDialogProps) => {
  const { visible, onCancel, isConfigService, onConfigService, ...otherProps } = props;
  const { t } = useTranslate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: JolectAuthFormValues) => {
    setLoading(true);
    try {
      const response = await authJolectShop({
        code: values.code,
        departmentIds: values.departmentIds,
      });
      const resData = response?.data?.data;
      if (resData?.isSuccess) {
        message.success(t('scene.storeAuth.jolectDialog.feedback.addSuccess'));
        onCancel?.({} as any);
      } else {
        message.error(resData?.errorMsg || t('scene.storeAuth.jolectDialog.feedback.addFailed'));
      }
    } catch (error: any) {
      message.error(error?.message || t('scene.storeAuth.jolectDialog.feedback.addFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      visible={visible}
      width={600}
      title={
        <TitleWrap>
          <TitleText className="center">{t('scene.storeAuth.jolectDialog.title')}</TitleText>
        </TitleWrap>
      }
      footer={null}
      maskClosable={false}
      closable
      onCancel={onCancel}
      bodyStyle={{ paddingTop: 64, paddingLeft: 24, paddingRight: 24, paddingBottom: 22 }}
      {...otherProps}
    >
      <Banner>
        <InfoCircleFilled style={{ color: 'var(--ant-primary-color)', fontSize: 14 }} />
        <span className="ml-2">{t('scene.storeAuth.jolectDialog.description.bannerTip')}</span>
      </Banner>
      <JolectAuthForm loading={loading} onSubmit={handleSubmit} />
    </Dialog>
  );
};

const Banner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding: 8px 24px;
  background-color: #e6f4ff;
  color: #262626;
`;

export default JolectAuthShopDialog;
